class resultSettlementHours {
  constructor(
    liqId,
    conceptId,
    csCostoId,
    settledAmount,
    authorizedAmount,
    unauthorizedAmount,
    nameLiq,
    nameEmp,
    namConcept,
    nameCost,
    licTot,
    CCQuantity
  ) {
    this.liqId = liqId;
    this.conceptId = conceptId;
    this.csCostoId = csCostoId;
    this.settledAmount = licTot === "N" ? hours(settledAmount) : settledAmount;
    this.authorizedAmount =
      licTot === "N" ? hours(authorizedAmount) : authorizedAmount;
    this.unauthorizedAmount =
      licTot === "N" ? hours(unauthorizedAmount) : unauthorizedAmount;
    this.nameLiq = nameLiq;
    this.nameEmp = nameEmp;
    this.namConcept = namConcept;
    this.nameCost = nameCost;
    this.licTot = licTot;
    this.CCQuantity = CCQuantity;
  }
  static fromJson({
    liqId,
    conceptoId,
    csCostoId,
    cantLiq,
    cantAut,
    cantNoAut,
    nomLiqM,
    nomEmp,
    nomConcepto,
    nomCsCosto,
    licTot,
    cantCC,
  }) {
    return new resultSettlementHours(
      liqId,
      conceptoId,
      csCostoId,
      cantLiq,
      cantAut,
      cantNoAut,
      nomLiqM,
      nomEmp,
      nomConcepto,
      nomCsCosto,
      licTot,
      cantCC
    );
  }
}
function hours(param) {
  let horas = Math.floor(param / 60);
  let min = Math.floor(horas * 60);
  min = param - min;
  if (horas < 10) {
    horas = "0" + horas;
  }
  min = min < 10 ? "0" + min : min;

  return horas + ":" + min;
}

export default resultSettlementHours;
